// src/config/systemConfig.ts
// Typed accessor for system_config.json — the single source of truth
// for environment definitions and tuneable parameters.
import raw from './system_config.json';

export interface EnvironmentDef {
  key: string;
  label: string;
  description: string;
  /** Full BFF origin for remote device-auth calls, e.g. `https://bff-dev.a.run.app`. */
  bff_base_url?: string;
}

export interface SystemConfig {
  environments: EnvironmentDef[];
  scope_migration: {
    scope_key_limit: number;
    default_source_env: string;
    default_target_env: string;
  };
  feature_flags: Record<string, boolean>;
}

export const systemConfig = raw as unknown as SystemConfig;

/** All defined environments (for dropdowns, etc.). */
export const ENVIRONMENTS: EnvironmentDef[] = systemConfig.environments;

/** Lookup by key. */
export function getEnvironment(key: string): EnvironmentDef | undefined {
  return ENVIRONMENTS.find((e) => e.key === key);
}

/**
 * Truthy check for a feature flag with a safe default.
 * Allows dynamic compile-time toggling by editing `system_config.json`
 * without touching any feature code — the canonical kill-switch path.
 */
export function isFeatureEnabled(key: string, defaultValue = false): boolean {
  const v = systemConfig.feature_flags?.[key];
  return typeof v === 'boolean' ? v : defaultValue;
}
